<table class="table table-striped table-vcenter">
    <thead>
        <tr>
            <ng-container *ngFor="let field of shownFields">
              <ng-container [ngSwitch]="field">
                <th *ngSwitchCase="DestinationField.Name">Name</th>
                <th *ngSwitchCase="DestinationField.Country">Country</th>
                <th *ngSwitchCase="DestinationField.HousingsTotal">
                    Total
                </th>
                <th *ngSwitchCase="DestinationField.HousingsDone">
                    Done
                </th>
                <th *ngSwitchCase="DestinationField.HousingsImported">
                    Imported
                </th>
                <th *ngSwitchCase="DestinationField.LastImportDate">
                    Last imported
                </th>
              </ng-container>
            </ng-container>
            <th>
                Actions
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let destination of destinations | paginate: { itemsPerPage: pagination.limit, currentPage: pagination.page, totalItems: pagination.total}">
            <ng-container *ngFor="let field of shownFields">
              <ng-container [ngSwitch]="field">
                <td class="name" *ngSwitchCase="DestinationField.Name">{{destination.boundary.googleResponse.formatted_address}}</td>
                <td *ngSwitchCase="DestinationField.Country">{{destination.boundary.mappedObj.country}}</td>
                <td *ngSwitchCase="DestinationField.HousingsTotal">
                    {{destination.statistics.TOTAL}}
                </td>
                <td *ngSwitchCase="DestinationField.HousingsDone">
                    {{destination.statistics.READY_FOR_PROD}}
                </td>
                <td *ngSwitchCase="DestinationField.HousingsImported">
                    {{destination.statistics.MOVED_TO_PROD}}
                </td>
                <td *ngSwitchCase="DestinationField.LastImportDate">
                  {{ destination.botMergeContainer?.lastImported ? (destination.botMergeContainer?.lastImported | date:'mediumDate') : 'N/A' }}
                </td>
              </ng-container>
            </ng-container>
            <td>
              <ng-container *ngFor="let field of shownFields">
                <ng-container [ngSwitch]="field">
                    <button
                      [ngClass]="{
                        'btn-primary': !destination.botMergeContainer?.isActive,
                        'btn-danger': destination.botMergeContainer?.isActive
                      }"
                      (click)="onActionClick(field, destination)" class="btn btn-sm mr-2" *ngSwitchCase="DestinationAction.Prepare">
                        {{ destination.botMergeContainer?.isActive ? "Stop prepare" : "Prepare" }}
                    </button>
                    <button (click)="onActionClick(field, destination)" class="btn btn-sm btn-info mr-2" *ngSwitchCase="DestinationAction.ImportStats">
                        Import stats
                    </button>
                    <button (click)="onActionClick(field, destination)" class="btn btn-sm btn-info mr-2" *ngSwitchCase="DestinationAction.InProgressStats">
                        Merge stats
                    </button>
                    <ng-container
                        *ngSwitchCase="DestinationAction.Import">
                      <button
                        *ngIf="destination.statistics.READY_FOR_PROD > 0 && (!importProgress || !importProgress[destination.boundary._id])"
                        (click)="onActionClick(field, destination)" class="btn btn-sm btn-success mr-2" >
                          Import
                      </button>

                      <ng-container *ngIf="importProgress && importProgress[destination.boundary._id]">
                        <div class="btn btn-sm btn-secondary">
                          Importing ({{importProgress[destination.boundary._id].percentage + '%'}})...
                        </div>
                      </ng-container>
                    </ng-container>
                    <button (click)="onActionClick(field, destination)" class="btn btn-sm btn-primary mr-2" *ngSwitchCase="DestinationAction.Download">
                        Download
                    </button>
                </ng-container>
              </ng-container>
            </td>
        </tr>
    </tbody>
</table>
<div class="block-content block-content-full block-content-sm text-center" *ngIf="destinations?.length > 0">

  <pagination-controls [maxSize]="10"
                       (pageChange)="sendPage($event)"
  ></pagination-controls>
</div>
